<template lang='pug'>
  .admin
    Navbar(admin)
    router-view
</template>

<script>
  import Navbar from '../../components/Navbar/Navbar'

  export default {
    name: 'Admin',
    components: {
      Navbar
    }
  }
</script>

<style lang='css'></style>



// WEBPACK FOOTER //
// Admin.vue?77b3a0c2